// extracted by mini-css-extract-plugin
module.exports = {"headerBar":"headerBar___2G7AR","sharingList":"sharingList___3MKI5","brandLogo":"brandLogo___-1gJz","brandTitle":"brandTitle___2XZbv"};